



import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {EventBusUploadModalType} from "@/share";
import {eventBusService} from "@/services";
import {MilestoneInterface} from "@/share/types/interface";

@Component({})
export default class StepDefinition extends Vue {
  @Prop({type: Boolean, default: false}) value!: boolean
  @Prop({type: Boolean, default: false}) disabled!: boolean
  @Prop() data!: MilestoneInterface

  private isChecked = false;

  @Watch('value', {immediate: true, deep: true})
  private onValueChange(value: boolean): void {
    if (this.disabled) this.isChecked = value
    if (!value) this.isChecked = value
  }

  private onChangeCheckBox() {
    const modalData = new EventBusUploadModalType({
      milestone: this.data
    })

    eventBusService.$emit(eventBusService.EVENT_SHOW_UPLOAD_MODAL, modalData)
  }
}
